import axiosInstance from './axiosInstance';

export interface OrderListParams {
  orderId?: string;
  productTitle?: string;
  userId?: string;
  userName?: string;
  orderStatus?: number;
  productType?: number;
  currentPage: number;
  pageSize: number;
}

export interface UserOrderDTO {
  orderId: string;
  userId: string;
  userName: string;
  orderType: number;
  productType: number;
  productTypeDesc: string;
  points: number;
  productInfoId: string;
  productTitle: string;
  productShowImage: string;
  productImage: string;
  productCount: number;
  orderStatus: number;
  sumPoints: number;
  createTime: string;
  payTime?: string;
}

export interface OrderListResponse {
  total: number;
  currentPage: number;
  pageSize: number;
  records: UserOrderDTO[];
}

export interface OrderDetailResponse {
  data: UserOrderDTO;
  status: number;
  success: boolean;
  message: string;
}

/**
 * 获取订单列表
 */
export const getOrderList = async (
  params: OrderListParams
): Promise<{
  data: OrderListResponse;
  status: number;
  success: boolean;
  message: string;
}> => {
  const res = await axiosInstance.get<{
    data: OrderListResponse;
    status: number;
    success: boolean;
    message: string;
  }>('/supp-management/api/order/v1/list', { params });

  return res.data;
};

/**
 * 获取订单详情
 */
export const getOrderDetail = async (
  orderId: string
): Promise<OrderDetailResponse> => {
  const res = await axiosInstance.get<OrderDetailResponse>(
    `/supp-management/order/detail/${orderId}`
  );
  return res.data;
};

/**
 * 退还积分
 */
export const restoreOrderPoints = async (params: {
  orderId: string;
  userId: string;
}): Promise<{
  status: number;
  success: boolean;
  message: string;
}> => {
  const res = await axiosInstance.post<{
    status: number;
    success: boolean;
    message: string;
  }>('/supp-management/order/restore', params);
  return res.data;
};
